import type { SidebarNavItem } from './sidebar.types'

import {
  IconGlobe,
  IconGift01,
  IconHash02,
  IconUsers01,
  IconHomeLine,
  IconLogOut04,
  IconPieChart03,
  IconTranslate01,
  IconCheckDone01,
  IconBarChartSquare02,
} from 'assets/icons'

export const sidebarNavItems: SidebarNavItem[] = [
  {
    id: 1,
    name: 'navigation.dashboard',
    href: '/dashboard',
    icon: IconHomeLine,
    readSubject: 'Dashboard',
  },
  {
    id: 2,
    name: 'navigation.applications',
    href: '/applications',
    icon: IconBarChartSquare02,
    readSubject: 'Applications',
  },
  { id: 3, name: 'navigation.markets', href: '/markets', icon: IconGlobe, readSubject: 'Markets' },
  {
    id: 4,
    name: 'navigation.translations',
    href: '/translations',
    icon: IconCheckDone01,
    readSubject: 'Translations',
  },
  {
    id: 5,
    name: 'navigation.prizes',
    href: '/prizes-groups',
    icon: IconPieChart03,
    readSubject: 'Prizes',
  },
  { id: 6, name: 'navigation.barcodes', href: '/barcodes', icon: IconHash02, readSubject: 'Barcodes' },
  {
    id: 7,
    name: 'navigation.marketLanguages',
    href: '/market-languages',
    icon: IconTranslate01,
    readSubject: 'Market Languages',
  },
  {
    id: 8,
    name: 'navigation.prizeDraw',
    href: '/winners-notifications',
    icon: IconGift01,
    readSubject: 'Import prizes',
  },
  {
    id: 8.1,
    name: 'navigation.adminWinners',
    href: '/prizes-tracker',
    icon: IconGift01,
    readSubject: 'Admin Import prizes',
  },
  {
    id: 8.2,
    name: 'navigation.embargoTracker',
    href: '/embargo-tracker',
    icon: IconGift01,
    readSubject: 'Admin Import prizes',
  },
  /* {
        id: '0001-0008',
        name: 'navigation.importPrizesApplications',
        href: '/winners-notifications-applications',
        icon: IconGift01,
        readSubject: 'Import prizes'
      }, */
  { id: 9, name: 'navigation.users', href: '/users', icon: IconUsers01, readSubject: 'Users' },
  { id: 10, name: 'navigation.logs', href: '/logs', icon: IconLogOut04, readSubject: 'Logs' },
]
